import { decimalPlaces, numberWithCommas } from './common-calculations-functions';
import { gtag_report_conversion_calculate_profit } from './conversion-tags';
import { setCalcValuesToCookie } from './save-to-cookie';
	/* variables */
	var quickCostOfProductInstinctNServePerAcre;
	var quickCostOfProductNServePerAcre;
	var quickCostOfProductInstinctPerAcre;
	var quickCostOfProductInstinctNServePerAcre;
	var quickCornYieldBushelsAcre;
	var quickAverageYieldIncreaseWithProductInstinctNServe;
	var quickCornPricePerBushel;
	var quickTotalAcres;
	var quickYieldIncreaseForquickTotalAcres;
	var quickYieldIncreasePerAcre;
	
	/* valid variables */
	var quickCostOfProductInstinct_or_NServePerAcreValid = true;	//using this validation variable for both NServe or Instinct products, because only one product only will be taken at calculation based on dropdown selectbox value.
	var quickCornYieldBushelsAcreValid = true;
	var quickAverageYieldIncreaseWithProductInstinctNServeValid = true;
	var quickCornPricePerBushelValid = true;
	var quickTotalAcresValid = true;
	
	
	$(document).ready(function(){
		/* quick-cost-of-product-instinct-per-acre */
		$("#quick-cost-of-product-instinct-per-acre").keyup(function(){
			quickCostOfProductInstinctPerAcre =$(this).val().replace(/,/g, '');
			if(quickCostOfProductInstinctPerAcre != ""){
				if(isNaN(quickCostOfProductInstinctPerAcre)) {
					$(this).addClass("input-error");
					quickCostOfProductInstinct_or_NServePerAcreValid = false;
					$(".quick-cost-of-product-instinct-per-acre-error-message").show();
				}
				else if(quickCostOfProductInstinctPerAcre <= 0) {
					$(this).addClass("input-error");
					 quickCostOfProductInstinct_or_NServePerAcreValid = false;
					 $(".quick-cost-of-product-instinct-per-acre-error-message").show();
				}
				else if(quickCostOfProductInstinctPerAcre.replace(/[^.]/g, "").length > 1){
					$(this).addClass("input-error");
					quickCostOfProductInstinct_or_NServePerAcreValid = false;
					$(".quick-cost-of-product-instinct-per-acre-error-message").show();
				}
				else if(decimalPlaces(quickCostOfProductInstinctPerAcre) > 2 ){
					$(this).addClass("input-error");
					quickCostOfProductInstinct_or_NServePerAcreValid = false;
					$(".quick-cost-of-product-instinct-per-acre-error-message").show();
				}
				else {	
					$(this).removeClass("input-error"); 
					quickCostOfProductInstinct_or_NServePerAcreValid = true;
					$(".quick-cost-of-product-instinct-per-acre-error-message").hide();
				}
			}
			else {
				$(this).removeClass("input-error"); 
				quickCostOfProductInstinct_or_NServePerAcreValid = true;
				$(".quick-cost-of-product-instinct-per-acre-error-message").hide();
			}
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		 });

		  $("#quick-cost-of-product-instinct-per-acre").blur(function(){
			  var currentValue=$(this).val().replace(/,/g, '');
			 
			if(currentValue == ""){
				$(this).removeClass("input-error"); 
				quickCostOfProductInstinct_or_NServePerAcreValid = true;
				$(".quick-cost-of-product-instinct-per-acre-error-message").hide();
			}
			else{
				//if no dot(.) is located, then this will execute by adding . with two 0's
				if(currentValue.replace(/[^.]/g, "").length <= 0){
					$(this).val(currentValue+".00");
				}
				else{
					if(decimalPlaces(currentValue) == 0){
						$(this).val(currentValue+"00");
					}
					else if(decimalPlaces(currentValue) > 2)
					{
						//remove extra decimals
					}
					else if(decimalPlaces(currentValue) == 2){
						// do nothing
					}
					else if(decimalPlaces(currentValue) == 1){
						// adding one ending decimal as 0
						$(this).val(currentValue+"0");
					}
				}
			}
			
			//validation in blur
			if(quickCostOfProductInstinct_or_NServePerAcreValid == false){
				$(".quick-cost-of-product-instinct-per-acre-error-message").show();
				$("#quick-cost-of-product-instinct-per-acre").addClass("input-error");
			}
			
			//adding commas to input values after blur
			currentValue = numberWithCommas($(this).val());
			$(this).val(currentValue);
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		});
		 
		 
		/* quick-cost-of-product-n-serve-per-acre */ 
		$("#quick-cost-of-product-n-serve-per-acre").keyup(function(){
			quickCostOfProductNServePerAcre =$(this).val().replace(/,/g, '');
			if(quickCostOfProductNServePerAcre != ""){
				if(isNaN(quickCostOfProductNServePerAcre)) {
					$(this).addClass("input-error");
					quickCostOfProductInstinct_or_NServePerAcreValid = false;
					$(".quick-cost-of-product-n-serve-per-acre-error-message").show();
				}
				else if(quickCostOfProductNServePerAcre <= 0) {
					$(this).addClass("input-error");
					 quickCostOfProductInstinct_or_NServePerAcreValid = false;
					 $(".quick-cost-of-product-n-serve-per-acre-error-message").show();
				}
				else if(quickCostOfProductNServePerAcre.replace(/[^.]/g, "").length > 1){
					$(this).addClass("input-error");
					quickCostOfProductInstinct_or_NServePerAcreValid = false;
					$(".quick-cost-of-product-n-serve-per-acre-error-message").show();
				}
				else if(decimalPlaces(quickCostOfProductNServePerAcre) > 2 ){
					$(this).addClass("input-error");
					quickCostOfProductInstinct_or_NServePerAcreValid = false;
					$(".quick-cost-of-product-n-serve-per-acre-error-message").show();
				}
				else {	
					$(this).removeClass("input-error"); 
					quickCostOfProductInstinct_or_NServePerAcreValid = true;
					$(".quick-cost-of-product-n-serve-per-acre-error-message").hide();
				}
			}
			else {
				$(this).removeClass("input-error"); 
				quickCostOfProductInstinct_or_NServePerAcreValid = true;
				$(".quick-cost-of-product-n-serve-per-acre-error-message").hide();
			}
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		 });

		  $("#quick-cost-of-product-n-serve-per-acre").blur(function(){
			  var currentValue=$(this).val().replace(/,/g, '');
			 
			if(currentValue == ""){
				$(this).removeClass("input-error"); 
				quickCostOfProductInstinct_or_NServePerAcreValid = true;
				$(".quick-cost-of-product-n-serve-per-acre-error-message").hide();
			}
			else{
				//if no dot(.) is located, then this will execute by adding . with two 0's
				if(currentValue.replace(/[^.]/g, "").length <= 0){
					$(this).val(currentValue+".00");
				}
				else{
					if(decimalPlaces(currentValue) == 0){
						$(this).val(currentValue+"00");
					}
					else if(decimalPlaces(currentValue) > 2)
					{
						//remove extra decimals
					}
					else if(decimalPlaces(currentValue) == 2){
						// do nothing
					}
					else if(decimalPlaces(currentValue) == 1){
						// adding one ending decimal as 0
						$(this).val(currentValue+"0");
					}
				}
			}
			
			//validation in blur
			if(quickCostOfProductInstinct_or_NServePerAcreValid == false){
				$(".quick-cost-of-product-n-serve-per-acre-error-message").show();
				$("#quick-cost-of-product-n-serve-per-acre").addClass("input-error");
			}
			
			//adding commas to input values after blur
			currentValue = numberWithCommas($(this).val());
			$(this).val(currentValue);
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		});
		
		
		
		/* quick-corn-yield-bushels-acre */
		$("#quick-corn-yield-bushels-acre").keyup(function(){
			quickCornYieldBushelsAcre =$(this).val().replace(/,/g, '');
			if(quickCornYieldBushelsAcre != ""){
				if(isNaN(quickCornYieldBushelsAcre)) {
					$(this).addClass("input-error");
					quickCornYieldBushelsAcreValid = false;
					$(".quick-corn-yield-bushels-acre-error-message").show();
				}
				else if(quickCornYieldBushelsAcre < 1) {
					$(this).addClass("input-error");
					 quickCornYieldBushelsAcreValid = false;
					 $(".quick-corn-yield-bushels-acre-error-message").show();
				}
				else if(quickCornYieldBushelsAcre.replace(/[^.]/g, "").length > 0){
					$(this).addClass("input-error");
					quickCornYieldBushelsAcreValid = false;
					$(".quick-corn-yield-bushels-acre-error-message").show();
				}
				else if(decimalPlaces(quickCornYieldBushelsAcre) > 0 ){
					$(this).addClass("input-error");
					quickCornYieldBushelsAcreValid = false;
					$(".quick-corn-yield-bushels-acre-error-message").show();
				}
				else {	
					$(this).removeClass("input-error"); 
					quickCornYieldBushelsAcreValid = true;
					$(".quick-corn-yield-bushels-acre-error-message").hide();
				}
			}
			else {
				$(this).addClass("input-error");
				quickCornYieldBushelsAcreValid = false;
				$(".quick-corn-yield-bushels-acre-error-message").show();
			}
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		 });

		  $("#quick-corn-yield-bushels-acre").blur(function(){
			  var currentValue=$(this).val().replace(/,/g, '');
			 
			if(currentValue == ""){
				$(this).addClass("input-error");
				quickCornYieldBushelsAcreValid = false;
				$(".quick-corn-yield-bushels-acre-error-message").show();
			}
			
			//validation in blur
			if(quickCornYieldBushelsAcreValid == false){
				$(".quick-corn-yield-bushels-acre-error-message").show();
				$("#quick-corn-yield-bushels-acre").addClass("input-error");
			}
			
			//adding commas to input values after blur
			currentValue = numberWithCommas($(this).val());
			$(this).val(currentValue);
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		});
		
		/* quick-average-yield-increase-with-product-instinct-n-serve */
		$("#quick-average-yield-increase-with-product-instinct-n-serve").keyup(function(){
			quickAverageYieldIncreaseWithProductInstinctNServe =$(this).val().replace(/,/g, '');
			quickAverageYieldIncreaseWithProductInstinctNServe =quickAverageYieldIncreaseWithProductInstinctNServe.replace(/%/g, '');		//newly added
			if(quickAverageYieldIncreaseWithProductInstinctNServe != ""){
				if(isNaN(quickAverageYieldIncreaseWithProductInstinctNServe)) {
					$(this).addClass("input-error");
					quickAverageYieldIncreaseWithProductInstinctNServeValid = false;
					$(".quick-average-yield-increase-with-product-instinct-n-serve-error-message").show();
				}
				//else if(quickAverageYieldIncreaseWithProductInstinctNServe <= 0) {}
				else if((quickAverageYieldIncreaseWithProductInstinctNServe < 3) || (quickAverageYieldIncreaseWithProductInstinctNServe > 10)) {
					$(this).addClass("input-error");
					 quickAverageYieldIncreaseWithProductInstinctNServeValid = false;
					 $(".quick-average-yield-increase-with-product-instinct-n-serve-error-message").show();
				}
				else if(quickAverageYieldIncreaseWithProductInstinctNServe.replace(/[^.]/g, "").length > 1){
					$(this).addClass("input-error");
					quickAverageYieldIncreaseWithProductInstinctNServeValid = false;
					$(".quick-average-yield-increase-with-product-instinct-n-serve-error-message").show();
				}
				else if(decimalPlaces(quickAverageYieldIncreaseWithProductInstinctNServe) > 2 ){
					$(this).addClass("input-error");
					quickAverageYieldIncreaseWithProductInstinctNServeValid = false;
					$(".quick-average-yield-increase-with-product-instinct-n-serve-error-message").show();
				}
				else {	
					$(this).removeClass("input-error"); 
					quickAverageYieldIncreaseWithProductInstinctNServeValid = true;
					$(".quick-average-yield-increase-with-product-instinct-n-serve-error-message").hide();
				}
			}
			else {
				$(this).addClass("input-error");
				quickAverageYieldIncreaseWithProductInstinctNServeValid = false;
				$(".quick-average-yield-increase-with-product-instinct-n-serve-error-message").show();
			}
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		 });

		  $("#quick-average-yield-increase-with-product-instinct-n-serve").blur(function(){
			  var currentValue=$(this).val().replace(/,/g, '');
			  currentValue =currentValue.replace(/%/g, '');		//newly added
			 
			if(currentValue == ""){
				$(this).addClass("input-error");
				quickAverageYieldIncreaseWithProductInstinctNServeValid = false;
				$(".quick-average-yield-increase-with-product-instinct-n-serve-error-message").show();
			}
			
			//validation in blur
			if(quickAverageYieldIncreaseWithProductInstinctNServeValid == false){
				$(".quick-average-yield-increase-with-product-instinct-n-serve-error-message").show();
				$("#quick-average-yield-increase-with-product-instinct-n-serve").addClass("input-error");
			}
			
			//adding commas to input values after blur
			currentValue =$(this).val().replace('%', '');	//newly added
			currentValue = numberWithCommas(currentValue);	//newly added
			currentValue = currentValue + "%";		//newly added
			$(this).val(currentValue);
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		});
		
		
		/* quick-corn-price-per-bushel */
		$("#quick-corn-price-per-bushel").keyup(function(){
			quickCornPricePerBushel =$(this).val().replace(/,/g, '');
			quickCornPricePerBushel =quickCornPricePerBushel.replace('$', '');		//newly added
			if(quickCornPricePerBushel != ""){
				if(isNaN(quickCornPricePerBushel)) {
					$(this).addClass("input-error");
					quickCornPricePerBushelValid = false;
					$(".quick-corn-price-per-bushel-error-message").show();
				}
				else if(quickCornPricePerBushel <= 0) {
					$(this).addClass("input-error");
					 quickCornPricePerBushelValid = false;
					 $(".quick-corn-price-per-bushel-error-message").show();
				}
				else if(quickCornPricePerBushel.replace(/[^.]/g, "").length > 1){
					$(this).addClass("input-error");
					quickCornPricePerBushelValid = false;
					$(".quick-corn-price-per-bushel-error-message").show();
				}
				else if(decimalPlaces(quickCornPricePerBushel) > 2 ){
					$(this).addClass("input-error");
					quickCornPricePerBushelValid = false;
					$(".quick-corn-price-per-bushel-error-message").show();
				}
				else {	
					$(this).removeClass("input-error"); 
					quickCornPricePerBushelValid = true;
					$(".quick-corn-price-per-bushel-error-message").hide();
				}
			}
			else {
				$(this).addClass("input-error");
				quickCornPricePerBushelValid = false;
				$(".quick-corn-price-per-bushel-error-message").show();
			}
		
			setCalcValuesToCookie(); //save changed data to cookie
			
		 });

		  $("#quick-corn-price-per-bushel").blur(function(){
			  var currentValue=$(this).val().replace(/,/g, '');
			  currentValue =currentValue.replace('$', '');		//newly added
			 
			if(currentValue == ""){
				$(this).addClass("input-error");
				quickCornPricePerBushelValid = false;
				$(".quick-corn-price-per-bushel-error-message").show();
			}
			else{
				//if no dot(.) is located, then this will execute by adding . with two 0's
				if(currentValue.replace(/[^.]/g, "").length <= 0){
					$(this).val(currentValue+".00");
				}
				else{
					if(decimalPlaces(currentValue) == 0){
						$(this).val(currentValue+"00");
					}
					else if(decimalPlaces(currentValue) > 2)
					{
						//remove extra decimals
					}
					else if(decimalPlaces(currentValue) == 2){
						// do nothing
					}
					else if(decimalPlaces(currentValue) == 1){
						// adding one ending decimal as 0
						$(this).val(currentValue+"0");
					}
				}
			}
			
			//validation in blur
			if(quickCornPricePerBushelValid == false){
				$(".quick-corn-price-per-bushel-error-message").show();
				$("#quick-corn-price-per-bushel").addClass("input-error");
			}
			
			//adding commas to input values after blur
			currentValue =$(this).val().replace('$', '');	//newly added
			currentValue = numberWithCommas(currentValue);	//newly added
			currentValue = "$" + currentValue;		//newly added
			$(this).val(currentValue);
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		});
		
		
		/* quick-total-acres */
		$("#quick-total-acres").keyup(function(){
			quickTotalAcres =$(this).val().replace(/,/g, '');
			if(quickTotalAcres != ""){
				if(isNaN(quickTotalAcres)) {
					$(this).addClass("input-error");
					quickTotalAcresValid = false;
					$(".quick-total-acres-error-message").show();
				}
				else if(quickTotalAcres < 1) {
					$(this).addClass("input-error");
					 quickTotalAcresValid = false;
					 $(".quick-total-acres-error-message").show();
				}
				else if(quickTotalAcres.replace(/[^.]/g, "").length > 0){
					$(this).addClass("input-error");
					quickTotalAcresValid = false;
					$(".quick-total-acres-error-message").show();
				}
				else if(decimalPlaces(quickTotalAcres) > 0 ){
					$(this).addClass("input-error");
					quickTotalAcresValid = false;
					$(".quick-total-acres-error-message").show();
				}
				else {	
					$(this).removeClass("input-error"); 
					quickTotalAcresValid = true;
					$(".quick-total-acres-error-message").hide();
				}
			}
			else {
				$(this).addClass("input-error");
				quickTotalAcresValid = false;
				$(".quick-total-acres-error-message").show();
			}
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		 });

		  $("#quick-total-acres").blur(function(){
			  var currentValue=$(this).val().replace(/,/g, '');
			 
			if(currentValue == ""){
				$(this).addClass("input-error");
				quickTotalAcresValid = false;
				$(".quick-total-acres-error-message").show();
			}
			
			//validation in blur
			if(quickTotalAcresValid == false){
				$(".quick-total-acres-error-message").show();
				$("#quick-total-acres").addClass("input-error");
			}
			
			//adding commas to input values after blur
			currentValue = numberWithCommas($(this).val());
			$(this).val(currentValue);
			
			setCalcValuesToCookie(); //save changed data to cookie
			
		});
	});
	
	
	//functions
	/* quick-result-value-of-yield-increase-per-acre Result calculation function */
	function quickYieldIncreasePerAcreResult(){
		if(quickCostOfProductInstinct_or_NServePerAcreValid == true && quickCornYieldBushelsAcreValid == true && quickAverageYieldIncreaseWithProductInstinctNServeValid == true && quickCornPricePerBushelValid == true){
			
			//removing comma's(,)
			//check value for "Cost of N-Serev/Instinct (per acre)" and get value as per product related to dropdown selection - start
			if($("#quick-nitrogen-source").val() == "anhydrous"){
				//for N-Serve option
				quickCostOfProductInstinctNServePerAcre = $("#quick-cost-of-product-n-serve-per-acre").val();
				quickCostOfProductInstinctNServePerAcre = quickCostOfProductInstinctNServePerAcre.replace(/,/g, '');
			}
			else{
				//for Instinct II options
				quickCostOfProductInstinctNServePerAcre = $("#quick-cost-of-product-instinct-per-acre").val();
				quickCostOfProductInstinctNServePerAcre = quickCostOfProductInstinctNServePerAcre.replace(/,/g, '');
			}
			//check value for "Cost of N-Serev/Instinct (per acre)" and get value as per product related to dropdown selection - end
			
			quickCornYieldBushelsAcre = $("#quick-corn-yield-bushels-acre").val();
			quickCornYieldBushelsAcre = quickCornYieldBushelsAcre.replace(/,/g, '');
			quickAverageYieldIncreaseWithProductInstinctNServe = $("#quick-average-yield-increase-with-product-instinct-n-serve").val();
			quickAverageYieldIncreaseWithProductInstinctNServe = quickAverageYieldIncreaseWithProductInstinctNServe.replace(/,/g, '');
			quickAverageYieldIncreaseWithProductInstinctNServe = quickAverageYieldIncreaseWithProductInstinctNServe.replace(/%/g, '');	//newly added
			quickCornPricePerBushel = $("#quick-corn-price-per-bushel").val();
			quickCornPricePerBushel = quickCornPricePerBushel.replace(/,/g, '');
			quickCornPricePerBushel = quickCornPricePerBushel.replace('$', '');	//newly added
			
			//formula //calculating Per acre
			quickYieldIncreasePerAcre = parseFloat((quickCornYieldBushelsAcre * (quickAverageYieldIncreaseWithProductInstinctNServe / 100) * quickCornPricePerBushel) - quickCostOfProductInstinctNServePerAcre);
			
			quickYieldIncreasePerAcre = quickYieldIncreasePerAcre.toFixed(2);
			quickYieldIncreasePerAcre = numberWithCommas(quickYieldIncreasePerAcre);
			//$("#quick-result-value-of-yield-increase-per-acre").text("$"+quickYieldIncreasePerAcre);
			if(quickYieldIncreasePerAcre.replace(/[^-]/g, "").length > 0){
				quickYieldIncreasePerAcre = quickYieldIncreasePerAcre.replace(/-/g, '');
				$("#quick-result-value-of-yield-increase-per-acre").text("-$"+quickYieldIncreasePerAcre);
			}else{
				$("#quick-result-value-of-yield-increase-per-acre").text("$"+quickYieldIncreasePerAcre);
			}
		}
	}
	
	/* quick-result-value-of-yield-increase-for-quick-total-acres Result calculation function */
	function quickYieldIncreaseForquickTotalAcresResult(){
		if(quickCostOfProductInstinct_or_NServePerAcreValid == true && quickCornYieldBushelsAcreValid == true && quickAverageYieldIncreaseWithProductInstinctNServeValid == true && quickCornPricePerBushelValid == true && quickTotalAcresValid == true){
			
			//removing comma's(,)
			//check value for "Cost of N-Serev/Instinct (per acre)" and get value as per product related to dropdown selection - start
			if($("#quick-nitrogen-source").val() == "anhydrous"){
				//for N-Serve option
				quickCostOfProductInstinctNServePerAcre = $("#quick-cost-of-product-n-serve-per-acre").val();
				quickCostOfProductInstinctNServePerAcre = quickCostOfProductInstinctNServePerAcre.replace(/,/g, '');
			}
			else{
				//for Instinct II options
				quickCostOfProductInstinctNServePerAcre = $("#quick-cost-of-product-instinct-per-acre").val();
				quickCostOfProductInstinctNServePerAcre = quickCostOfProductInstinctNServePerAcre.replace(/,/g, '');
			}
			//check value for "Cost of N-Serev/Instinct (per acre)" and get value as per product related to dropdown selection - end
			quickCornYieldBushelsAcre = $("#quick-corn-yield-bushels-acre").val();
			quickCornYieldBushelsAcre = quickCornYieldBushelsAcre.replace(/,/g, '');
			quickAverageYieldIncreaseWithProductInstinctNServe = $("#quick-average-yield-increase-with-product-instinct-n-serve").val();
			quickAverageYieldIncreaseWithProductInstinctNServe = quickAverageYieldIncreaseWithProductInstinctNServe.replace(/,/g, '');
			quickAverageYieldIncreaseWithProductInstinctNServe = quickAverageYieldIncreaseWithProductInstinctNServe.replace(/%/g, '');	//newly added
			quickCornPricePerBushel = $("#quick-corn-price-per-bushel").val();
			quickCornPricePerBushel = quickCornPricePerBushel.replace(/,/g, '');
			quickCornPricePerBushel = quickCornPricePerBushel.replace('$', '');	//newly added
			quickTotalAcres = $("#quick-total-acres").val();
			quickTotalAcres = quickTotalAcres.replace(/,/g, '');

			//show value to results
			$("#quick-entered-input-total-acres").text(numberWithCommas(quickTotalAcres));
			
			
			//check value for "Cost of N-Serev/Instinct (per acre)" and set default value as given in excel sheet or use overwritten text box value - start
			//if no value is inside input box, then apply default values
			//check value for "Cost of N-Serev/Instinct (per acre)" and set default value as given in excel sheet or use overwritten text box value - end
			
			//formula //calculating For Total Acres
			quickYieldIncreaseForquickTotalAcres = parseFloat((quickCornYieldBushelsAcre * (quickAverageYieldIncreaseWithProductInstinctNServe / 100) * quickCornPricePerBushel) - quickCostOfProductInstinctNServePerAcre) * quickTotalAcres;
			
			quickYieldIncreaseForquickTotalAcres = quickYieldIncreaseForquickTotalAcres.toFixed(2);
			quickYieldIncreaseForquickTotalAcres = numberWithCommas(quickYieldIncreaseForquickTotalAcres);
			if(quickYieldIncreaseForquickTotalAcres.replace(/[^-]/g, "").length > 0){
				quickYieldIncreaseForquickTotalAcres = quickYieldIncreaseForquickTotalAcres.replace(/-/g, '');
				$("#quick-result-value-of-yield-increase-for-quick-total-acres").text("-$"+quickYieldIncreaseForquickTotalAcres);
			}else{
				$("#quick-result-value-of-yield-increase-for-quick-total-acres").text("$"+quickYieldIncreaseForquickTotalAcres);
			}
		}
	}


	
$('[data-calculate-btn]').click(function() {
	quickYieldIncreaseForquickTotalAcresResult();
	quickYieldIncreasePerAcreResult();
	$('[data-email-button]').attr('disabled', false);

	// append floodlight
	var axel = Math.random() + "";
	var a = axel * 10000000000000;
	document.getElementById("profit-calculate-floodlight").innerHTML = ' \
	<img src="https://ad.doubleclick.net/ddm/activity/src=9667705;type=caag_00-;cat=caag_0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + a + '?" width="1" height="1" alt=""/> \
	<img src="https://ad.doubleclick.net/ddm/activity/src=9667705;type=caag_00-;cat=caag_0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" alt=""/>';

	if(typeof gtag == 'function') {
		gtag_report_conversion_calculate_profit();
	}
});
